<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
     Procurement Order List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
              Add Procurement Order
            </v-btn>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item link>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('all')}"
                    
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item link>
            <downloadExcel
                    class = "btn"
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item link>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('filter')}"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-select
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
      >
      </v-text-field>
        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      single-expand
      show-expand
      :footer-props="{'items-per-page-options':[30, 50, 100]}"
    >

    <template v-slot:[`header.procurement_order_status`]="{ header }">
      <v-select
        style=" font-size:10px;"
        :items="optionStatus"
        :label="header.text"
        v-model="valueStatus"
        @change="getList"
        item-text="text"
        item-value="value"
              
        class="ma-2"
        hide-details
      >
      </v-select>
    </template>
   
     <template v-slot:[`item.detail`]="{ item }">
          <router-link :to="{name: 'Detail Procurement Order', params: { id: item.id }}" class="btn btn-primary">Detail
          </router-link>
    </template>
     <template v-slot:[`item.dealer_name`]="{ item }">
       {{ item.procurement_order_dealer.dealer_name }}
     </template>
     <!-- <template v-slot:[`item.procurement_order_item`]="{ item }">
         <div v-for="item_name in item.procurement_order_item" :key="item_name.id">
                <span v-if="item_name.spare_part_price.part_master">{{ item_name.spare_part_price.part_master.spare_part_master_name+' ('+ item_name.item_procurement_order_qty +')'}}</span><br>

              </div>
    </template> -->
     <template v-slot:[`item.procurement_order_status`]="{ item }">
          <span v-if="item.procurement_order_status==0">Registered</span>
          <span v-else-if="item.procurement_order_status==1">Waiting Manager Approval</span>
          <span v-else-if="item.procurement_order_status==2">Rejected</span>
          <span v-else-if="item.procurement_order_status==3">Waiting Price Check</span>
          <span v-else-if="item.procurement_order_status==4">Waiting CEO Approval</span>
          <span v-else-if="item.procurement_order_status==5">Waiting Payment</span>
          <span v-else-if="item.procurement_order_status==6">Payment Done</span>
          <span v-else-if="item.procurement_order_status==7">Item Received</span>
          <span v-else-if="item.procurement_order_status==8">Canceled</span>
          <span v-else-if="item.procurement_order_status==9">On Hold</span>
    </template>

    <template  v-slot:expanded-item="{ headers, item }">
      <td class="pa-5" :colspan="headers.length">
      <!-- Faktur are closed: -->
        <md-table class="ma-5">
          <md-table-row >
            <md-table-head style="text-align: center;"><b>No</b></md-table-head>
            <md-table-head style="text-align: center;"><b>Item Name</b></md-table-head>
            <md-table-head style="text-align: center;"><b>Qty</b></md-table-head>
            <md-table-head style="text-align: center;"><b>Amount</b></md-table-head>
            <md-table-head style="text-align: center;"><b>Total Amount</b></md-table-head>
          </md-table-row>
          <md-table-row  v-for="(items, index)  in item.procurement_order_item" :key="index">
            <md-table-cell style="text-align: center;">{{ index+1 }}</md-table-cell>
            <!-- <md-table-cell style="text-align: center;"><span v-if="items.spare_part_price && items.spare_part_price.part_master">{{ items.spare_part_price.part_master.spare_part_master_name }}</span></md-table-cell> -->
            <md-table-cell style="text-align: center;"><span v-if="items.spare_part">{{ items.spare_part.spare_part_master_name }}</span></md-table-cell>
            <md-table-cell style="text-align: center;">{{ items.item_procurement_order_qty }}</md-table-cell>
            <md-table-cell style="text-align: center;">Rp. {{ formatPrice( items.item_procurement_price) }}</md-table-cell>
            <md-table-cell style="text-align: center;">Rp. {{ formatPrice( items.item_procurement_order_qty * items.item_procurement_price) }}</md-table-cell>
          </md-table-row>
        </md-table>
      </td>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          
          <v-list-item @click="detailPO(item.id)">
            <v-list-item-title x-small>Detail</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="(role.create || role.update) && item.procurement_order_attach_invoice_url==null && (item.procurement_order_status == 5 || item.procurement_order_status == 6 || item.procurement_order_status == 7)" @click="uploadInvoice(item.id)">
            <v-list-item-title x-small>Upload Invoice</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="(item.procurement_order_status == 5 || item.procurement_order_status == 6 || item.procurement_order_status == 7) && item.procurement_order_attach_payment_url==null && (check_object_value(division,'name',['Admin']) || check_object_value(division,'division_id',[8]))" @click="uploadPaymentProof(item.id)">
            <v-list-item-title x-small>Upload Payment Proof</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item 
            v-if="(item.procurement_order_status == 0 && role.update) ||
                  (item.procurement_order_status == 6 && role.update)"
                  @click="editPO(item.id)"> -->
            <v-list-item 
              v-if="(item.procurement_order_status == 0 && role.update)"
              @click="editPO(item.id)"
            >
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item v-if="role.delete && item.driver_status == 0" @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
  <modal ref="modalAddPage">
    <template v-slot:header>
      <div style="text-align:center; margin:auto;">
      <h3 >ADD PROCUREMENT ORDER</h3>
      </div>
      <md-button class="md-icon-button md-dense md-round"  @click="modalCloseAdd()">
        <md-icon >close</md-icon>
      </md-button>
    </template>
    <template v-slot:body >
      <add-po />
    </template>
  </modal>
  <modal ref="modalEditPage">
    <template v-slot:header>
      <div style="text-align:center; margin:auto;">
      <h3 >EDIT PROCUREMENT ORDER</h3>
      </div>
      <md-button class="md-icon-button md-dense md-round"  @click="modalCloseEdit()">
        <md-icon >close</md-icon>
      </md-button>
    </template>
    <template v-slot:body >
      <edit-po :data_id="$refs.modalEditPage.data"/>
    </template>
  </modal>
  <modal ref="modalDetailPage">
    <template v-slot:body >
      <detail-po :data_id="$refs.modalDetailPage.data" />
    </template>
  </modal>
  <modal ref="modalUploadPaymentProofPage" class="coba">
    <template v-slot:body >
      <upload-payment-proof :data_id="$refs.modalUploadPaymentProofPage.data" />
    </template>
  </modal>
  <modal ref="modalUploadInvoicePage" class="coba">
    <template v-slot:body >
      <upload-invoice :data_id="$refs.modalUploadInvoicePage.data" />
    </template>
  </modal>
  
</div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import JsonExcel from "vue-json-excel";
import AddPO from "@/pages/Dashboard/Workshop/ProcurementOrder/AddPOPage.vue";
import DetailPO from "@/pages/Dashboard/Workshop/ProcurementOrder/DetailPOPage.vue";
import EditPO from "@/pages/Dashboard/Workshop/ProcurementOrder/EditPOPage.vue";
import UploadPaymentProof from "@/pages/Dashboard/Workshop/ProcurementOrder/Modal/uploadPaymentProof.vue";
import UploadInvoice from "@/pages/Dashboard/Workshop/ProcurementOrder/Modal/uploadInvoice.vue";
import { Modal } from "@/components";
import { ResizablePage } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage, Modal, "add-po" : AddPO, "detail-po" : DetailPO, "edit-po" : EditPO, "upload-payment-proof": UploadPaymentProof,
    "upload-invoice": UploadInvoice
  },
    vuetify,
    data () {
      return {
        mounted:true,
        searchValue:null,
        searchCategory:null,
        division:null,
        option_filter: [ 
          { text: 'PO No', value: 'procurement_order_no' },
          { text: 'Dealer Name', value: 'dealer_name' }],
        valueStatus:'',
        optionStatus:[ 
          { text: 'All', value: '' },
          { text: 'On Hold', value: '9' },
          { text: 'Canceled', value: '8' },
          { text: 'Item Received', value: '7' },
          { text: 'Payment Done', value: '6' },
          { text: 'Waiting Payment', value: '5' },
          { text: 'Waiting CEO Approval', value: '4' },
          { text: 'Waiting Price Check', value: '3' },
          { text: 'Rejected', value: '2' },
          { text: 'Waiting Manager Approval', value: '1'},
          { text: 'Registered', value: '0'}],
        page: 1,
        totalDataTable: 0,
        numberOfPages: 0,
        loadTable: true,
        role: "",
        search: '',
        options: {},
        headers: [
          
          // {
          //   text: 'Detail',
          //   align: 'start center',
          //   value: 'detail',
          //   sortable: false
          // },
          {
            text: 'Actions',
            align: 'start center',
            value: 'actions',
            sortable: false
          },
          { text: '', value: 'data-table-expand' },
          { text: 'Procurement Order No', value: 'procurement_order_no' },
          { text: 'Dealer Name', value: 'dealer_name'},
          // { text: 'Item', value: 'procurement_order_item' , sortable : false},
          { text: 'Status', value: 'procurement_order_status', sortable : false},
          { text: 'Created At', value: 'created_at', align: 'center'},
        ],
        table: [],
        worksheetName: "Procurement Order",
        fileName:"Procurement Order.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        exportAll:[],
        field_export: {
            no: "no",
          "Procurement Order No": "procurement_order_no",
          "Remark": "procurement_order_remark",
          "Url Attachment Quotation": "procurement_order_attach_quotation_url",
          "Url Attachment PO": "procurement_order_attach_po_url",
          "Url Attachment Invoice": "procurement_order_attach_invoice_url",
          "Url Attachment Payment": "procurement_order_attach_payment_url",
          "Status": "procurement_order_status",
          "Dealer Name": "dealer_name",
          "PPN/No PPN": "dealer_use_ppn",
          "Dealer Attn": "dealer_attn",
          "Dealer Phone": "dealer_phone",
          "Dealer Address": "dealer_address",
          "Dealer Bank Name": "dealer_bank_name",
          "Dealer Bank Account": "dealer_bank_account",
          "No. Item": "no_item",
          "Spare Part Code": "spare_part_master_code",
          "Spare Part Name": "spare_part_master_name",
          "Spare Part Price": "spare_part_price_price",
          "Qty": "item_procurement_order_qty",
          "Total": "total",
          "Spare Part minimum Order Quantity":
            "spare_part_price_minimum_order_quantity",
          "Spare Part Alert Price": "spare_part_master_alert_price",
          "Created At": "created_at",
          "Updated At": "updated_at",
        },
      }
    },

    watch: {
    options: {
      handler() {
        if( !this.mounted){
          this.getList();
        }
      },
    },
    deep: true,
  },
    async mounted() {
      //set refs in root saat page terbuka, agar fungsi di page ini bisa di panggil dari page lain
      this.$root.$refs.ListPoPage = this;
      //check saat page terbuka apakah ada params 
      if(this.$route.params.id){
        console.log(this.$route.params.id);
        //open detail
        this.detailPO(this.$route.params.id)
      }
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      var me = await this.$store.getters["profile/me"]
        // this.role.role = me.role_name.name_string.split(",") 
        this.division = me.role_name
      
    this.getList();
    this.mounted = false
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      var query = {"page":{number:pageNumber,size:itemsPerPage}}

      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort
      }

      if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }

      if(this.valueStatus!=''){
        if(query.filter){
          Object.assign(query.filter, {procurement_order_status:this.valueStatus});
        }
        else{
          query.filter = {procurement_order_status:this.valueStatus}
        }
      }
    
      await this.$store.dispatch("workshop_procurement_order/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["workshop_procurement_order/list"];
        var pageMeta  = await this.$store.getters["workshop_procurement_order/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta)
      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
    },

    formatPrice(value) {
        let val = (value/1).toFixed().replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

    searchButton(){
       this.options.page = 1;
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
       this.options.page = 1;
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    // if(this.$refs.vTable){
    //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    // }
    // else{
    //   this.exportAllFitered = this.dataExport(this.table)
    // }
    },

    //fungsi untuk pinda ke page tambah
    // addData() {
    //   // panggil page add data
    //   this.$router.push({ name: "Add Procurement Order" });
    // },

    uploadInvoice(id){
      this.$refs.modalUploadInvoicePage.openModal({id:id});
    },

    modalCloseUploadInvoice(){
      this.$refs.modalUploadInvoicePage.closeModal();
      this.getList();
    },

    uploadPaymentProof(id){
      this.$refs.modalUploadPaymentProofPage.openModal({id:id});
    },

    modalCloseUploadPaymentProof(){
      this.$refs.modalUploadPaymentProofPage.closeModal();
      this.getList();
    },

    addData(){
      this.$refs.modalAddPage.openModal()
    },
    modalCloseAdd(){
      this.$refs.modalAddPage.closeModal();
      this.getList();

    },

    detailPO(id){
      this.$refs.modalDetailPage.openModal({id:id})
    },

    modalCloseDetail(){
      this.$refs.modalDetailPage.closeModal();
      this.getList();

    },

    editPO(id){
      this.$refs.modalEditPage.openModal({id:id})
    },

    modalCloseEdit(){
      this.$refs.modalEditPage.closeModal()
    },

    async dataExportBefore(type){
      if(this.table.length!=0){
        
        if(type=="all"){
          await this.$store.dispatch("workshop_procurement_order/list");
          return this.dataExport(await this.$store.getters["workshop_procurement_order/list"]);
        }
        else if(type=="filter"){

          var query = {}


            if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }

            

            if(this.valueStatus!=''){
              if(query.filter){
                Object.assign(query.filter, {procurement_order_status:this.valueStatus});
              }
              else{
                query.filter = {procurement_order_status:this.valueStatus}
              }
            }
          
            await this.$store.dispatch("workshop_procurement_order/list",query);
             return this.dataExport(await this.$store.getters["workshop_procurement_order/list"]);
        }
      }
    },

    check_object_value(array, key, value) {
        //return array.some(object => object[key] === value);
        return array.some(object => value.includes(object[key]));
        },

     dataExport(data){
     
     var dataReturn=[]
      data.forEach((value_1, index_1) => {
        var procurement_order_status = null

        if(value_1.procurement_order_status == 0){
          procurement_order_status = "Registered"
        }
        else if(value_1.procurement_order_status == 1){
          procurement_order_status = "Waiting Manager Approval"
        }
        else if(value_1.procurement_order_status == 2){
          procurement_order_status = "Rejected"
        }
        else if(value_1.procurement_order_status == 3){
          procurement_order_status = "Waiting Price Check"
        }
        else if(value_1.procurement_order_status == 4){
          procurement_order_status = "Waiting CEO Approval"
        }
        else if(value_1.procurement_order_status == 5){
          procurement_order_status = "Waiting Payment"
        }
        else if(value_1.procurement_order_status == 6){
          procurement_order_status = "Payment Done"
        }
        else if(value_1.procurement_order_status == 7){
          procurement_order_status = "Item Received"
        }
        else if(value_1.procurement_order_status == 8){
          procurement_order_status = "Cancel"
        }
        else if(value_1.procurement_order_status == 9){
          procurement_order_status = "Hold"
        }
        
        if (value_1.procurement_order_item.length != 0) {
          value_1.procurement_order_item.forEach((value_2, index_2) => {
            var no = null;
            if (index_2 == 0) {
              no = index_1 + 1;
            }
            var data = {
              no: no,
              procurement_order_no: value_1.procurement_order_no,
              procurement_order_remark: value_1.procurement_order_remark,
              procurement_order_attach_quotation_url:
                value_1.procurement_order_attach_quotation_url,
              procurement_order_attach_po_url: value_1.procurement_order_attach_po_url,
              procurement_order_attach_invoice_url:
                value_1.procurement_order_attach_invoice_url, 
              procurement_order_attach_payment_url:
                value_1.procurement_order_attach_payment_url,
              procurement_order_status: procurement_order_status,
              dealer_name: value_1.procurement_order_dealer.dealer_name,
              dealer_use_ppn: value_1.procurement_order_dealer.dealer_use_ppn,
              dealer_attn: value_1.procurement_order_dealer.dealer_attn,
              dealer_phone: value_1.procurement_order_dealer.dealer_phone,
              dealer_address: value_1.procurement_order_dealer.dealer_address,
              dealer_bank_name:
                value_1.procurement_order_dealer.dealer_bank_name,
              dealer_bank_account:
                value_1.procurement_order_dealer.dealer_bank_account,
              no_item: index_2 + 1,
              spare_part_master_code: value_2.spare_part?value_2.spare_part.spare_part_master_code:null,
              spare_part_master_name: value_2.spare_part?value_2.spare_part.spare_part_master_name:null,
              spare_part_price_price: value_2.item_procurement_price,
              item_procurement_order_qty: value_2.item_procurement_order_qty,
              total:
                value_2.item_procurement_price *
                value_2.item_procurement_order_qty,
              spare_part_price_minimum_order_quantity: value_2.spare_part_price?
                value_2.spare_part_price.spare_part_price_minimum_order_quantity:null,
              spare_part_master_alert_price:
              value_2.spare_part?value_2.spare_part.spare_part_master_alert_price:null,
              created_at: value_1.created_at,
              updated_at: value_1.updated_at,
            };
            dataReturn.push(data)
          });
        } else {
          var data = {
            no: index_1 + 1,
            procurement_order_no: value_1.procurement_order_no,
            procurement_order_remark: value_1.procurement_order_remark,
            procurement_order_attach_quotation_url:
              value_1.procurement_order_attach_quotation_url,
            procurement_order_attach_po_url: value_1.procurement_order_attach_po_url,
            procurement_order_attach_invoice_url:
              value_1.procurement_order_attach_invoice_url,
            procurement_order_attach_payment_url:
              value_1.procurement_order_attach_payment_url,
            procurement_order_status: value_1.procurement_order_status,
            dealer_name: value_1.procurement_order_dealer.dealer_name,
            dealer_use_ppn: value_1.procurement_order_dealer.dealer_use_ppn,
            dealer_attn: value_1.procurement_order_dealer.dealer_attn,
            dealer_phone: value_1.procurement_order_dealer.dealer_phone,
            dealer_address: value_1.procurement_order_dealer.dealer_address,
            dealer_bank_name: value_1.procurement_order_dealer.dealer_bank_name,
            dealer_bank_account:
              value_1.procurement_order_dealer.dealer_bank_account,
            no_item: null,
            spare_part_master_code: null,
            spare_part_master_name: null,
            spare_part_price_price: null,
            item_procurement_order_qty: null,
            total: null,
            spare_part_price_minimum_order_quantity: null,
            spare_part_master_alert_price: null,
            created_at: value_1.created_at,
            updated_at: value_1.updated_at,
          };
          dataReturn.push(data)
        }
      });
      return dataReturn
    },
  
     },
  }
</script>
<style lang="scss" scoped>
.coba {
  width: 800px !important;
  margin: 50px auto !important;
  // top: auto !important;
  // bottom: auto !important;
  height: auto !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
  }
}

.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>